import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Plus } from "lucide-react";

export default function Experiments() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ hypothesis: "", variable: "", control: "", variant: "", target_metric: "reach", min_sample: 3 });

  const load = () => api.get("/experiments").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.hypothesis) return;
    await api.post("/experiments", form);
    toast.success("Experiment created");
    setForm({ hypothesis: "", variable: "", control: "", variant: "", target_metric: "reach", min_sample: 3 });
    load();
  };

  return (
    <div className="p-8 max-w-[1200px]">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-widest text-neutral-500 font-semibold mb-1">Experiments</div>
        <h1 className="text-5xl font-black tracking-tight leading-none" style={{ fontFamily: "'Cabinet Grotesk', system-ui, sans-serif" }}>Test one thing at a time</h1>
      </div>

      <div className="bg-white border border-neutral-200 rounded-lg p-4 mb-6">
        <div className="text-xs uppercase tracking-widest text-neutral-500 font-semibold mb-3">New experiment</div>
        <div className="grid grid-cols-2 gap-3">
          <input data-testid="exp-hypothesis" placeholder="Hypothesis" value={form.hypothesis} onChange={(e) => setForm({ ...form, hypothesis: e.target.value })} className="border border-neutral-300 rounded px-3 py-2 text-sm col-span-2" />
          <input data-testid="exp-variable" placeholder="Variable being tested" value={form.variable} onChange={(e) => setForm({ ...form, variable: e.target.value })} className="border border-neutral-300 rounded px-3 py-2 text-sm" />
          <input data-testid="exp-metric" placeholder="Target metric (reach, shares, etc)" value={form.target_metric} onChange={(e) => setForm({ ...form, target_metric: e.target.value })} className="border border-neutral-300 rounded px-3 py-2 text-sm" />
          <input data-testid="exp-control" placeholder="Control" value={form.control} onChange={(e) => setForm({ ...form, control: e.target.value })} className="border border-neutral-300 rounded px-3 py-2 text-sm" />
          <input data-testid="exp-variant" placeholder="Variant" value={form.variant} onChange={(e) => setForm({ ...form, variant: e.target.value })} className="border border-neutral-300 rounded px-3 py-2 text-sm" />
        </div>
        <button data-testid="add-exp-btn" onClick={add} className="mt-3 px-4 py-2 rounded font-semibold text-sm text-neutral-900 flex items-center gap-1" style={{ background: "#D4FF00" }}><Plus className="w-3 h-3" />Add</button>
      </div>

      {items.map((e) => (
        <div key={e.id} className="bg-white border border-neutral-200 rounded-lg p-4 mb-2">
          <div className="text-xs uppercase tracking-widest text-neutral-500 font-semibold">{e.decision}</div>
          <div className="font-bold text-lg mt-1">{e.hypothesis}</div>
          <div className="text-sm text-neutral-600 mt-1">Variable: <span className="font-semibold">{e.variable}</span> · Metric: {e.target_metric}</div>
          <div className="text-xs text-neutral-500 mt-1">Control: {e.control} vs Variant: {e.variant}</div>
        </div>
      ))}
    </div>
  );
}
